import React, { useState } from "react";
import { useTransition, animated } from "react-spring";
import { stepStyles } from "./formStyles";

export const LoanOfficer = ({ formData, setForm, navigation }) => {
  const [isVisible] = useState(true);

  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(200px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });

  return (
    <div className={stepStyles.page}>
      <div className={stepStyles.content}>
        {transition((style, item) =>
          item ? (
            <animated.div style={style} className={stepStyles.panel}>
              <h1 className={stepStyles.title}>Are you working with a loan officer already?</h1>
            </animated.div>
          ) : null,
        )}
      </div>
      <div className={stepStyles.actionBar}>
        <div className={stepStyles.actionRow}>
          <div className="w-full md:w-auto">
            <a href="https://onetrusthomeloans.com/mlo-search">
              <button className={`${stepStyles.buttonAlt} w-full`}>Yes</button>
            </a>
          </div>
          <div className="w-full md:w-auto">
            <button className={`${stepStyles.button} w-full`} onClick={() => navigation.next()}>
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
